// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__MZkfq","white":"Checkbox_white__a4Qjb","label":"Checkbox_label__H6KqJ","round":"Checkbox_round__aKD1Q"};